import {
  CoreRegistrationFieldsFragment,
  InvoiceFragment,
  RegistrationRequestFieldsForUserFragment,
  ReportViolationRegistrationFieldsFragment,
} from '@/utils/graphqlSdk'
import {InvoiceDocumentContext} from '@/utils/invoices/types'

import {TrademarkTypeValue} from '../constants'
import {Jurisdiction} from '../countries/constants'
import {DocumentLocation} from '../document/types'
import {ipOfficePriceIncreaseInfo, RegistrationRequestStatus} from './constants'
import {IpOfficePriceIncreaseAlertType} from './types'

export const isOrderCompleted = (
  request: CoreRegistrationFieldsFragment,
  invoice?: InvoiceFragment | null,
) => {
  return Boolean(
    request?.tracking_actions?.find(
      (action) => action.name === RegistrationRequestStatus.orderCreated,
    ) &&
      (!!invoice?.revolut_public_order_id || isFullDiscountOrder(invoice?.document_context)),
  )
}

export const isFullDiscountOrder = (context: InvoiceDocumentContext): boolean => {
  return Math.abs(context.invoiceContent.total.withVat) <= Number.EPSILON
}

export type TrademarkValue = {
  pathOrText: string
  value: string
  logoDocument: DocumentLocation | null
}

export const getTrademarkValue = (
  request:
    | CoreRegistrationFieldsFragment
    | ReportViolationRegistrationFieldsFragment
    | RegistrationRequestFieldsForUserFragment,
): TrademarkValue => {
  const logoDocument = request.logo_document[0]
  return {
    pathOrText: request.type === TrademarkTypeValue.image ? logoDocument.path : request.value,
    value: request.value,
    logoDocument: logoDocument
      ? {
          id: logoDocument.id,
          hubId: logoDocument.document_hub_id,
        }
      : null,
  }
}

export const getActiveIpOfficePriceIncreaseInfo = (): IpOfficePriceIncreaseAlertType[] =>
  Object.entries(ipOfficePriceIncreaseInfo)
    .map(([jurisdiction, config]) =>
      config && config.isVisibleToClient
        ? {jurisdiction: jurisdiction as Jurisdiction, ...config}
        : undefined,
    )
    .filter((item): item is IpOfficePriceIncreaseAlertType => item !== undefined)
